// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Register_wrapperComponent__SDboU","contentWrapper":"Register_contentWrapper__T7i93","content":"Register_content__GrVbx","heading":"Register_heading__hp91H"};